var exports = {
  "i": "x24da60e8--8b5a90--wrapper",
  "M": "x24da60e8--8b5a90--bar",
};

module.exports = exports;
